export const without = <T>(array: T[], ...values: T[]): T[] => {
  if (!Array.isArray(array) || !array.length) return []
  return array.filter((item) => !values.includes(item))
}
